import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { statusCountsKeys } from "@/lib/query-keys";
import type { StatusCounts } from "@/types/domain";

/** Conteos de licitaciones guardadas por estado, para el badge del sidebar. */
export function useStatusCounts(enabled = true) {
  return useQuery({
    queryKey: statusCountsKeys.all,
    enabled,
    staleTime: 30_000,
    queryFn: async () => {
      const res = await fetchToBackend<any>("/dashboard/getStatusCounts");
      return (res?.data ?? res) as StatusCounts;
    },
  });
}
